// in 32.x.x hasAnyPermissions replace with import { hasAnyPermissions } from '../../../utils/helpers';
import { hasAnyPermissions, isSkunexusUser } from '../utils';
import { withCustomUserGridHoc } from './HOCs/CustomUserGridHoc';

export default {
    name: 'userGridPage',
    before: [],
    after: [],
    setup: (app) => {
        const routeName = 'users';
        const route = app.routes.getItem(routeName);
        if (route) {
            const routeProps = route.props;

            route.props = (state) => ({
                ...routeProps(state),
                permissions: {
                    canChangePassword: hasAnyPermissions('users.change-password') && isSkunexusUser(),
                    //to remove in 32.x.x
                    canAdd: hasAnyPermissions('users.create'),
                    withExport: true,
                    canEditCustomAttributes: hasAnyPermissions('users - custom attributes.value edit'),
                    canEdit: hasAnyPermissions('users.update'),
                    canShow: hasAnyPermissions('users.show'),
                    canDelete: hasAnyPermissions('users.delete'),
                    withUserLink: hasAnyPermissions('users.show'),
                },
            });
            route.render = withCustomUserGridHoc(app);
            app.routes.changeItem(routeName, route);
        }
    },
};
